// this is the store module for prophyResults.vue

const prophyStatus = {
  namespaced: true,
  state: {
    selectedRecurringResponse: {},
    selectedMonth: '',
    allUsersBaselineAnswers: {},
    allUsersRecurringAnswers: {},
    userBaselineAnswers: {},
    userRecurringAnswers: {}
  },
  getters: {
    selectedStudy: (state) => {
      if (state.selectedRecurringResponse.hasOwnProperty('study')) {
        return state.selectedRecurringResponse.study
      } else {
        return null
      }
    },
    selectedMonthUserAnswer: (state) => {
      if (state.selectedMonth === 0) {
        return state.userBaselineAnswers
      } else {
        return (state.userRecurringAnswers.hasOwnProperty(state.selectedMonth) ? state.userRecurringAnswers[state.selectedMonth] : null)
      }
    },
    selectedMonthAllUserAnswers: (state) => {
      const answers = state.allUsersRecurringAnswers;
      const month = state.selectedMonth;

      if (state.selectedMonth === 0) {
        return state.allUsersBaselineAnswers
      } else {
        let output = {};
        for (let key in answers) {
          let qn = {
            questionid: answers[key].questionid,
            title: answers[key].title,
            nb_answers: 0,
            data: []
          }
          //  filter answers if they exist for that month
          if (answers[key].nb_answers[month] && answers[key].data[month]) {
            qn.nb_answers = answers[key].nb_answers[month];
            qn.data = answers[key].data[month];
          }
          output[key] = qn;
        }
        return output;
      }
    }
  },
  mutations: {
    setSelectedRecurringResponse: (state, payload) => {
      state.selectedRecurringResponse = payload
    },
    setSelectedMonth: (state, payload) => {
      state.selectedMonth = parseInt(payload)
    },
    setAllUsersBaselineAnswers: (state, payload) => {
      state.allUsersBaselineAnswers = payload.allUsersBaselineAnswers;
    },
    setAllUsersRecurringAnswers: (state, payload) => {
      state.allUsersRecurringAnswers = payload.allUsersRecurringAnswers;
    },
    setUserBaselineAnswers: (state, payload) => {
      state.userBaselineAnswers = payload.userBaselineAnswers;
    },
    setUserRecurringAnswers: (state, payload) => {
      state.userRecurringAnswers = payload.userRecurringAnswers;
    }
  },
  actions: {
    updateSelectedRecurringResponse ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setSelectedRecurringResponse', payload)
        resolve()
      })
    },
    updateSelectedMonth ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setSelectedMonth', payload)
        resolve()
      })
    },
    updateAllUsersBaselineAnswers ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setAllUsersBaselineAnswers', payload);
        resolve();
      })
    },
    updateAllUsersRecurringAnswers ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setAllUsersRecurringAnswers', payload);
        resolve();
      })
    },
    updateUserBaselineAnswers ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setUserBaselineAnswers', payload);
        resolve();
      })
    },
    updateUserRecurringAnswers ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setUserRecurringAnswers', payload);
        resolve();
      })
    }
  }
}

export default prophyStatus



// WEBPACK FOOTER //
// ./src/store/modules/prophyStatus.js